import { AlpineComponent } from 'alpinejs';

type ProviderEditFormData = {
  addSelectedOption: (e: Event) => void;
  populateInput: (ids: string[], processInput: string) => void;
  removeSelectedOption: (e: Event) => void;
}

interface SelectableHTMLElement extends HTMLElement {
  selectedOptionIds: string[];
}

export default ():AlpineComponent<ProviderEditFormData> => ({
  init() {
    // Open seminar section if hash is set in URL
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      const section = document.getElementById(hash) as HTMLElement;
      if (section) {
        section.classList.add('toggled');
      }
    }

    // Selectable options
    const selectAreas = document.querySelectorAll('.select-object-area') as NodeListOf<HTMLElement>;
    if (selectAreas) {
      selectAreas.forEach((area) => {
        (area as SelectableHTMLElement).selectedOptionIds = [];

        const ulList = area.querySelector('.awesomplete > ul') as HTMLElement;
        const userInput = area.querySelector('.awesomplete input.relational-object') as HTMLInputElement;

        // User input
        if (userInput) {
          userInput.addEventListener("click", () => {
            if (ulList) {
              ulList.removeAttribute('hidden');
            }
          });

          document.addEventListener("click", (event) => {
            const target = event.target as HTMLElement;
            if (ulList && !userInput.contains(target) && !ulList.contains(target)) {
              ulList.setAttribute('hidden', 'hidden');
            }
          });
        }

        // Selected options
        const selectedOptions = area.querySelectorAll('.selected-objects .relational-object') as NodeListOf<HTMLElement>;
        if (selectedOptions) {
          selectedOptions.forEach((selectedOption) => {
            const userId = (selectedOption as HTMLElement).dataset.userid;
            if (userId) {
              (area as SelectableHTMLElement).selectedOptionIds.push(userId);
            }
          });

          let processInput = '';
          processInput = area.dataset.process || '';
          this.populateInput((area as SelectableHTMLElement).selectedOptionIds, processInput);
        }

        // List of available options
        const listOptions = area.querySelectorAll('.awesomplete > ul li') as NodeListOf<HTMLElement>;
        if (listOptions) {
          // Remove selected options from the list - on load
          listOptions.forEach((option) => {
            const userId = (option as HTMLElement).dataset.userid;
            if (userId && (area as SelectableHTMLElement).selectedOptionIds.includes(userId)) {
              option.remove();
            }
          });
        }
      });
    }
  },

  // Remove selected options from the list
  removeSelectedOption(e) {
    const target = e.currentTarget as HTMLElement;
    const valueEl = target.querySelector('.relational-object--label') as HTMLElement;
    const value = valueEl.innerHTML;
    const userId = target.dataset.userid;

    const objArea = target.closest('.select-object-area') as HTMLElement;
    const ulList = target.closest('.select-object-area')?.querySelector('.awesomplete > ul') as HTMLElement;
    if (ulList) {
      const objectArea = target.closest('.select-object-area') as HTMLElement;
      let processInput = '';
      if (objectArea) {
        processInput = objectArea.dataset.process || '';
      }

      const listItem = document.createElement('li');
      listItem.setAttribute('aria-selected', 'false');
      listItem.addEventListener('click', this.addSelectedOption.bind(this));
      listItem.dataset.userid = userId;
      listItem.textContent = value;
      ulList.appendChild(listItem);
      target.remove();

      if (userId) {
        const hiddenInput = objArea.querySelector('input.hidden-input') as HTMLInputElement;
        if (hiddenInput) {
          let inputArray: string[] = [];
          const inputVal = hiddenInput.value;
          if (inputVal) {
            inputArray = inputVal.split(',');
            inputArray = inputArray.filter(id => id !== userId);
            this.populateInput(inputArray, processInput);
          }
        }
      }
    }
  },

  // Add selected options to the list
  addSelectedOption(e) {
    const target = e.currentTarget as HTMLElement;
    const objArea = target.closest('.select-object-area') as HTMLElement;
    const placeArea = target.closest('.select-object-area')?.querySelector('.selected-objects') as HTMLElement;
    if (placeArea) {
      const objectArea = target.closest('.select-object-area') as HTMLElement;

      let processInput = '';
      if (objectArea) {
        processInput = objectArea.dataset.process || '';
      }

      const userId = target.dataset.userid;
      const anchor = document.createElement('a');
      anchor.href = 'javascript:void(0);';
      anchor.addEventListener('click', this.removeSelectedOption.bind(this));
      anchor.className = 'relational-object';
      anchor.dataset.userid = userId;
      const span = document.createElement('span');
      span.className = 'relational-object--label';
      span.textContent = target.innerHTML;
      anchor.appendChild(span);
      placeArea.appendChild(anchor);
      target.remove();

      if (userId) {
        const hiddenInput = objArea.querySelector('input.hidden-input') as HTMLInputElement;
        if (hiddenInput) {
          let inputArray: string[] = [];
          const inputVal = hiddenInput.value;
          if (inputVal) {
            inputArray = inputVal.split(',');
          }
          inputArray.push(userId);
          this.populateInput(inputArray, processInput);
        }
      }

      const ulList = target.closest('.select-object-area')?.querySelector('.awesomplete > ul') as HTMLElement;
      if (ulList) {
        ulList.setAttribute('hidden', 'hidden');
      }
    }
  },

  populateInput($ids, $processInput) {
    const finalInput = document.querySelector('input#' + $processInput) as HTMLInputElement;
    if (finalInput) {
      finalInput.value = $ids.join(',');
    }
  }
});
